import {WuButton, WuMenu, WuMenuItem} from '@npm-questionpro/wick-ui-lib'
import React, {useState} from 'react'
import {cx} from '../../utils'
import styles from './Popover.module.scss'

interface IPopoverClassNames {
  root?: string
  openIcon?: string
  content?: string
  item?: string
}

interface IPopoverItem {
  value: string
  name?: string
  icon?: React.ReactNode
  object?: unknown
}

interface IPopoverProps {
  content: IPopoverItem[]
  onSelect?: (name: string, object?: unknown) => void
  onClick?: () => void
  icon: React.ReactNode
  ariaLabel: string
  testId?: string
  classNames?: IPopoverClassNames
}

export const Popover: React.FC<IPopoverProps> = ({
  content,
  onSelect,
  onClick,
  icon,
  ariaLabel,
  testId = '',
  classNames = {},
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const handleSelect = (item: IPopoverItem): void => {
    setIsOpen(false)
    if (onSelect) {
      if (item.object) onSelect(item.value, item.object)
      else onSelect(item.value)
    }
  }

  const handleOpenChange = (open: boolean): void => {
    if (onClick) {
      onClick()
      setIsOpen(false)
      return
    }
    setIsOpen(open && !!content?.length)
  }

  return (
    <div
      className={cx(
        styles.popover,
        isOpen && styles.popoverOpen,
        classNames.root,
      )}
      data-testid={testId}
    >
      <WuMenu
        open={isOpen}
        onOpenChange={handleOpenChange}
        className={classNames.content}
        Trigger={
          (
            <WuButton
              type="button"
              variant="secondary"
              iconOnly
              Icon={icon}
              aria-label={ariaLabel}
              className={cx(styles.popoverOpenIcon, classNames.openIcon)}
              id={'popover-icon'}
              onClick={(e: React.MouseEvent) => e.stopPropagation()}
            />
          ) as React.ReactElement<HTMLButtonElement>
        }
      >
        {content?.map((item, index) => (
          <WuMenuItem
            id={item.value}
            key={index}
            className={cx(styles.popoverContentItem, classNames.item)}
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation()
              handleSelect(item)
            }}
          >
            {item?.icon && <span>{item.icon}</span>}
            {item?.name && <span>{item.name}</span>}
          </WuMenuItem>
        ))}
      </WuMenu>
    </div>
  )
}
